import { render } from "./CouponsForm.vue?vue&type=template&id=4584d384"
import script from "./CouponsForm.vue?vue&type=script&lang=js"
export * from "./CouponsForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giovanialves/Documents/projects/vue/web.vidalonga/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__